import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import Loading from 'src/components/Loading';
import Router from './router';
import './styles/index.scss';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <BrowserRouter>
    <Suspense fallback={<Loading />}>
      <Router />
    </Suspense>
  </BrowserRouter>
);
